import { GameObject } from '../base/GameObject';
import { Earth } from './Earth';
import Phaser from 'phaser';

export class IceEarth extends Earth {
  constructor(scene: Phaser.Scene, x: number, y: number) {
    // Call parent constructor with proper parameters
    super(scene, x, y, 1500, 0.1, 6, 25000, 0);
    
    // Set specific properties
    this.damageResistance = 0.1;
    this.specialAbility = 'Freeze';
    this.abilityCooldown = 25000;
  }

  override useSpecialAbility(): void {
    this.freezeNearbyMonsters();
  }

  override activateAbility(): void {
    this.playAbilityEffect();
    this.freezeNearbyMonsters();
  }

  private freezeNearbyMonsters(): void {
    // Freeze nearby monsters
    const radius = 180;
    const freezeDuration = 2500; // ms
    const monsters = this.scene.children.list.filter(child =>
      child instanceof GameObject &&
      child.x !== undefined && child.y !== undefined &&
      Phaser.Math.Distance.Between(this.x, this.y, child.x, child.y) <= radius &&
      typeof (child as any).applyFreeze === 'function'
    );
    for (const m of monsters) {
      (m as any).applyFreeze(freezeDuration);
    }
  }

  override upgrade(): void {
    this.level++;
    this.baseMaxHealth += 250;
    this.baseDefense += 0.02;
    this.damageResistance += 0.02;
    this.recalculateStats();
    this.health = this.effectiveMaxHealth;
  }

  override playAbilityEffect(): void {
    // Ice crystallization effect around Earth
    for (let i = 0; i < 12; i++) {
      const angle = (Math.PI * 2 * i) / 12;
      const distance = 60 + Math.random() * 30;
      const x = this.x + Math.cos(angle) * distance;
      const y = this.y + Math.sin(angle) * distance;
      
      const crystal = this.scene?.add.polygon(x, y, '0 -8 7 4 -7 4', 0x87ceeb, 0.8);
      if (crystal && this.scene?.tweens) {
        crystal.setDepth(this.depth + 1);
        
        this.scene.tweens.add({
          targets: crystal,
          scaleX: 2,
          scaleY: 2,
          alpha: 0,
          rotation: Math.PI,
          duration: 2000,
          ease: 'Power2.easeOut',
          onComplete: () => crystal.destroy()
        });
      }
    }
  }

  protected getAtmosphereColor(): number {
    return 0x87ceeb; // Sky blue
  }

  protected getEnergyColor(): number {
    return 0x00ffff; // Cyan
  }

  protected getParticleColor(): number {
    return 0x4682b4; // Steel blue
  }

  protected getShieldColor(): number {
    return 0x1e90ff; // Dodger blue
  }

  protected getCoreColor(): number {
    return 0x0000ff; // Pure blue
  }
} 